import React from 'react';

import { ClientSafeTenantConfig } from 'server/config-cache/types';

const ConfigContext = React.createContext<ClientSafeTenantConfig | null>(null);

export default ConfigContext;
